import {Component, EventEmitter, HostBinding, HostListener, Input, Output, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatRipple, MatRippleModule, RippleAnimationConfig} from '@angular/material/core';
import {TSize, TVariant} from './interface';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, MatRippleModule, MatProgressSpinnerModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  providers: [MatRipple],
})
export class ButtonComponent {
  rippleAnimation: RippleAnimationConfig = {
    enterDuration: 350,
    exitDuration: 350,
  };

  diameter: Record<TSize, number> = {
    default: 24.5,
    lg: 26.25,
    sm: 24.5,
  };

  get spinnerColor() {
    return this.outline ? 'primary' : 'white';
  }

  constructor(
    private ripple: MatRipple,
  ) {
  }

  @Input() variant: TVariant = 'primary';
  @Input() size: TSize = 'default';
  @Input() loading: boolean;
  @Input() keepWidthOnLoading: boolean = true;
  @Input() loadingCaption: string;
  @Input() icon: string;

  // bootstrap button
  @Input() @HostBinding('class.btn') button = true;
  @Input() @HostBinding('class.disabled') disabled: boolean;
  @Input() @HostBinding('class.outline') outline: boolean;

  @Input() @HostBinding('class') get c() {
    return `btn-${this.variant} btn-${this.size} ${this.icon && 'icon' || ''}`;
  }

  @HostListener('mousedown', ['$event']) onmousedown(event) {
    this.ripple.launch(event.x, event.y, {animation: this.rippleAnimation});
  }
}
